<template>
  <section class="mt-5">
    <h2>パスワードのお問い合わせ</h2>
    <div class="form-content">
      <p>
        会員サイトご利用に必要なパスワードをご案内します。下記項目をご入力の上、「パスワードを送信する」ボタンを押してください。
      </p>
      <div class="form-member my-5">
        <div class="inner">
          <dl>
            <dt>会員番号</dt>
            <dd>
              <input
                v-model="userID"
                ref="userID"
                type="text"
                maxlength="100"
                style="ime-mode: disabled"
              />
              <p class="alert_txt" v-show="errors.userID != ''">{{ errors.userID }}</p>
              <p>
                ・ご使用頂いている会員番号を入力してください。
              </p>
            </dd>
            <dt>
              メールアドレス
            </dt>
            <dd>
              <input
                v-model="mailAddress"
                ref="mailAddress"
                type="email"
                class=""
                style="ime-mode: disabled"
              />
              <p class="alert_txt" v-show="errors.mailAddress != ''">{{ errors.mailAddress }}</p>
            </dd>
          </dl>
          <div class="box-p-20 text-center mt-5">
            <button v-on:click="putData" type="submit" id="Send" @click="Send">
              パスワードを送信する
            </button>
          </div>
          <div class="box-p-20 text-center">
            <router-link to="/login" class="btn">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ログインへ戻る&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";

let request = new Request();

export default {
  data() {
    return {
      userID: "",
      mailAddress: "",
      errors: {
        userID: "",
        mailAddress: "",
      },
    };
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {
    Send() {
      this.errors.userID = "";
      this.errors.mailAddress = "";
      if (this.userID == "") {
        console.log('error')
        this.errors.userID = "会員番号を入力してください";
      }
      if (this.mailAddress == "") {
        this.errors.mailAddress = "メールアドレスを入力してください";
      }

      if (this.errors.userID != "" || this.errors.mailAddress != "") {
        return false;
      }

      let postParmas = [this.userID, this.mailAddress];
      let requestParams = request.createParams(
        "webMdlLogin",
        "sendPassword",
        postParmas
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status && data.status == "good") {


              Message.info().fire({
                title: "ご登録のメールアドレスにパスワードを送信しました。",
                text: "メールが届かない場合は、しばらくたってからもう一度送信してください。",
              });


/*
            // ログイン情報を保存するかどうか
            if (this.omit) {
              auth.setLoginInfo(this.no, this.passwd, this.omit);
            } else {
              auth.clearLoginInfo();
            }
            auth.login(data.uid, data.Member, data.Shopping);
          } else {
            let msg = data.msg.split("\t");
            if (msg.length > 1) {
              Message.error().fire({
                title: "ログインに失敗しました",
                text: msg[1],
              });
            } else {
              Message.error().fire({
                title: "ログインに失敗しました",
                text: data.msg,
              });
            }*/


          }
        });
    },
  },
};
</script>
